import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import orderBy from 'lodash/orderBy';
import {getServicesList} from '../../actions/outgoingService';
import {makeOutgoingCall, resetCall, showWebphone} from '../../actions/call';
import Loader from '../Components/Loader';
// import {modifyAgentInfo} from '../../actions/getAgentConfig';
import classnames from 'classnames';
import { logData } from '../../utils/utils';

class AskForService extends Component {

  constructor(props) {
    super(props);
    this.state = {
        isShow: false,
        showErr: true,
        errorHeight: 0,
        showModal:props.showModal,
        searchFilter: '',
        link_disabled: false,
    };
  }
  close = (key) => {
    this.props.resetCall();
    this.props.handleClose(key);
  }
  // gets outgoing servie list from api
  getServiceList = () => {
    this.setState({
      service: this.props.payload.service_id,
      searchFilter: '',
      showErr: false,
      loading: this.props.servicesList.length == 0
    })
    if(this.props.servicesList.length == 0){
      this.props.getServicesList().then(() => {
        // logData('Got list');
        this.setState({
          loading: false
        })
      }, (err) => {
        this.setState({
          loading: false,
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        });
        logData(err);
      });
    }
  }
  // updates state with selected service
  changeService = (type) => {
    this.setState({service: type});
  }
  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }
  // renders list with outgoing service list
  renderList = () => {
    return orderBy(this.props.servicesList, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
    .filter(service => service.name && service.name.toLowerCase()
    .includes(this.state.searchFilter.toLowerCase()))
    .map(item => {
      return (
        <button
          key={item.id}
          type="button"
          onClick={() => this.changeService(item.id)}
          className={classnames(`list-group-item list-group-item${this.props.theme}`, {active: this.state.service==item.id})}>
          {item.name}
        </button>
      )
    });
  }
  getErrorHeight = () => {
    const errorHeight = document.getElementById('alertWrapper').clientHeight;
    this.setState({
      errorHeight: errorHeight + 21
    });
  }
  // updates state with search filter value
  handleSearchServiceChange = (e) => {
    this.setState({
      searchFilter: e.target.value
    });
  }
  // submit new outgoing service
  handleSubmit = () => {
    const agent_id = localStorage.getItem("agent_id");
    const client_id = localStorage.getItem("clientId");
    if(!this.state.service){
      this.setState({
        showErr: true,
        errorMsg: this.props.translations.selectOutgoingService[this.props.selectedLanguage]
      }, () => {
        this.getErrorHeight();
      });
      return;
    }else{
      const payload = this.props.payload;
      payload.service_id = this.state.service;

      if (! this.state.link_disabled)
      {
          // console.log('CLICK no more!! Panel de telefonia');
          this.state.link_disabled = true;
          setTimeout(() => { 
              this.state.link_disabled = false;
              // console.log('CLICK ok!! Panel de telefonia');
          }, 5000);

          this.props.showWebphone(true);
          this.props.resetCall();
          this.props.makeOutgoingCall(payload).then((res) => {

              // console.log('LLAMO POR SERVICIO');
              if(res.data.result===true)
              {
                  this.props.handleClose('showModal');
                  let selectedServiceName = ''
                  const servicesList = this.props.servicesList
                  for (const outgoingService of servicesList)
                  {
                      if (outgoingService.id === this.state.service)
                      {
                          selectedServiceName = outgoingService.name;
                      }
                  }   
    
                  // console.log('ENVIO CAMBIO DE SERVICIO POR DEFECTO');
                  window.mq.send(`/exchange/signal.${client_id}/user.${agent_id}`, {}, `{"tag":"service_change","data" : "${this.state.service}", "name":"${selectedServiceName}"}`);
              }
              else
              {
                  this.setState({
                     showErr: true,
                     errorMsg: this.props.translations.callFailed[this.props.selectedLanguage]
                  }, () => {
                      this.getErrorHeight();
                  });
              }
          }, () => {
              this.setState({
                  showErr: true,
                  errorMsg: this.props.translations.callFailed[this.props.selectedLanguage]
              }, () => {
                  this.getErrorHeight();
              });
          });
      }
    }
  }

  render(){
    const { loading, showErr, errorHeight } = this.state;
    const { translations, selectedLanguage, servicesList } = this.props;
    return (
      <Modal
        onEnter={this.getServiceList}
        show={this.props.showModal}
        onHide={() => this.close('showModal')}
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.outgoingService[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {showErr && <div className="alertWrapper" id="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          {(!loading && servicesList.length>0) && <div className="input-with-icon w-full">
          <input
            type="text"
            className={`form-control${this.props.theme} input-smm${this.props.theme}`}
            placeholder={translations.search[selectedLanguage]}
            style={ {marginBottom: '0.5rem'} }
            onChange={ this.handleSearchServiceChange }
          />
          <span className="icon icon-magnifying-glass" />
          </div>}
          <div className="list-group" style={{maxHeight: showErr ? `calc(345px - ${errorHeight}px)` : 345, overflow: 'auto'}}>
            {loading && <Loader width="20px" height="20px" />}
            {this.renderList()}
            {(!loading && servicesList.length==0) &&
              <h5>{translations.noOutgoingService[selectedLanguage]}</h5>
            }
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button
            type="button"
            onClick={() => this.close('showModal')}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
            style={ { width: !loading && servicesList.length>0 ? '50%' : '100%' } }
          >
            {translations.cancel[selectedLanguage]}
          </button>
          {(!loading && servicesList.length>0) && <button type="submit" onClick={this.handleSubmit} className={`btn btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.call[selectedLanguage]}</strong>
          </button>}
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        servicesList: state.servicesList,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        theme: state.common.theme
    };
}
function mapDispatchToProps (dispatch) {
    return bindActionCreators({getServicesList, makeOutgoingCall, resetCall, showWebphone}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AskForService);



// WEBPACK FOOTER //
// ./src/agent/modals/AskForService.js